import {useSsrContext} from '@shared/frontends/use_ssr_context';

export function useIsMobile(): boolean {
  const {userAgent} = useSsrContext();
  return /mobile|iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile|ipad|android|android 3.0|xoom|sch-i800|playbook|tablet|kindle/iu.test(
    userAgent
  );
}
